import { cn } from '@/context/global/utils/cn';

export type IconPreviousProps = {
  className?: string;
  size?: number;
};

export default function IconPrevious({ className = '', size = 32 }: IconPreviousProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M26.9866 9.62706V22.3871C26.9866 25.0004 24.1466 26.6404 21.88 25.3337L16.3466 22.147L10.8133 18.947C8.54661 17.6404 8.54661 14.3737 10.8133 13.067L16.3466 9.86705L21.88 6.68041C24.1466 5.37374 26.9866 7.00039 26.9866 9.62706Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.01367 24.2407V7.76074"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
